import { render, staticRenderFns } from "./TablePanel.vue?vue&type=template&id=2275b019&scoped=true&"
import script from "./TablePanel.vue?vue&type=script&lang=js&"
export * from "./TablePanel.vue?vue&type=script&lang=js&"
import style0 from "./TablePanel.vue?vue&type=style&index=0&id=2275b019&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2275b019",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VTextField})
